import type { LegalDocumentContent } from './types';

export const termsAndroidContent: LegalDocumentContent = {
  title: 'Terms & Conditions',
  intro:
    'These terms apply to the LuvLust Android app and one-time in-app purchases made through the Google Play Store.',
  sections: [
    {
      title: '1. Acceptance of Terms',
      paragraphs: [
        'By downloading, installing, or using our app, you agree to be bound by these terms and conditions. If you do not agree to these terms, please do not use the app.',
      ],
    },
    {
      title: '2. Contracting the Services',
      paragraphs: [
        'In order to use premium services, you must be of legal age and use the Google Play Store to download and purchase within the app.',
        'Once the application has been downloaded, when starting it for the first time, you may optionally answer questions related to general data linked to the application. All this information can be modified at any time through the corresponding configuration panel.',
        'You have a free version with limited content. To unlock premium content, you may purchase individual packs or bundle packs through one-time in-app purchases.',
      ],
    },
    {
      title: '3. Price and Period of Validity',
      paragraphs: [
        'LuvLust will inform you prior to purchase, through the Play Store and within the app, the price of available products. These prices, unless expressly stated otherwise, do not include communication costs or any other additional services.',
      ],
    },
    {
      title: '4. One-Time Purchases',
      paragraphs: [
        'LuvLust on Android offers one-time in-app purchases for permanent access to purchased premium content.',
      ],
      listItems: [
        'Individual mode packs and bundle packs may be offered',
        'Purchasing a bundle may unlock multiple related content packs',
        'The price shown at checkout is the full amount charged once',
      ],
    },
    {
      title: '5. Payment Methods and Security',
      paragraphs: [
        'Payments are processed by Google through your Google account. We do not have access to your payment information and do not store such information.',
        'Google Play terms apply: https://play.google.com/intl/en_us/about/play-terms/',
      ],
    },
    {
      title: '6. Applicable Taxes',
      paragraphs: [
        'All prices shown are final prices at the time of purchase, subject to applicable taxes as determined by Google.',
      ],
    },
    {
      title: '7. Price Changes',
      paragraphs: [
        'LuvLust reserves the right to modify prices at any time. For one-time purchases, the price charged is the price displayed at the time of purchase. Once completed, the price paid is not affected by subsequent price changes.',
      ],
    },
    {
      title: '8. Invoicing',
      paragraphs: [
        'Once payment has been made, Google provides the corresponding receipt or proof of purchase.',
      ],
    },
    {
      title: '9. Lifetime / One-Time Purchase Terms',
      listItems: [
        'Permanent Access: A one-time purchase provides ongoing access to the content included in the purchased package. No recurring charges apply.',
        'Scope: Content included is defined at the time of purchase. New additions may require a separate purchase.',
        'Non-Transferable: Purchases are tied to your Google account used at the time of purchase.',
        'Refunds: Subject to Google Play refund policies.',
        'Restore: Purchases can be restored via the "Restore Purchases" option with the same Google account.',
      ],
    },
    {
      title: '10. Contact',
      paragraphs: ['Questions about these terms: starlitapps.dev@gmail.com'],
    },
  ],
};
